import { RADashboardLayout } from "@/interfaces/raDashboard.interface"
import { RADashboardPortfolioType } from "../asset-enums"
import { RADashboardTabId } from "../tab-enums"
import DefaultMasterDashboardLayout from "./defaultMaster"

export const DefaultDashboardFixedIncome: RADashboardLayout = {
  ...DefaultMasterDashboardLayout,
  suggestedPortfolioType: [RADashboardPortfolioType.FixedIncome],
  initialTab: RADashboardTabId.FactorLens,
  tabLayouts: {
    ...DefaultMasterDashboardLayout.tabLayouts
  }
}

export default DefaultDashboardFixedIncome;